import { create } from 'zustand'

export const useAssessmentStore = create((set) => ({
    isSetRequest: false,

    setRequest: (data) => {
        set({isSetRequest: data})
    }
}));